import classNames from 'classnames';
import { action, computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import { IAppOnlyStore } from 'stores/AllStores';

// Styles
const s = require('./RemindersAlert.css');
const noteIcon = require('./../../assets/note.svg');
const closeIcon = require('./../../assets/close blue icon.svg');

// Props
// tslint:disable-next-line:no-empty-interface
interface IRemindersAlertProps extends IAppOnlyStore {}

// Component
@inject('store')
@observer
export class RemindersAlert extends React.Component<IRemindersAlertProps, {}> {
    @computed
    private get remindersCount(): number {
        return this.props.store.activities.activitiesToRemindAbout.length;
    }

    @computed private get hasPendingReminders(): boolean {
        return this.remindersCount > 0;
    }

    @computed private get remindersAreOpen(): boolean {
        return this.props.store.activities.showRemindersCenter;
    }

    public render() {
        return (
            <CSSTransitionGroup
                className={s.container}
                component="div"
                transitionName="show"
                transitionAppear={true}
                transitionEnter={true}
                transitionLeave={true}
                transitionAppearTimeout={800}
                transitionEnterTimeout={800}
                transitionLeaveTimeout={300}
            >
                {(this.hasPendingReminders || this.remindersAreOpen) && (
                    <button
                        className={classNames(s.alert, {
                            [s.isOpen]: this.remindersAreOpen,
                        })}
                        onClick={this.showReminders}
                    >
                        <p>
                            {this.remindersCount > 99
                                ? '99+'
                                : this.remindersCount}
                        </p>

                        <img className={s.noteIcon} src={noteIcon} alt="" />
                        <img className={s.closeIcon} src={closeIcon} alt="" />
                    </button>
                )}
            </CSSTransitionGroup>
        );
    }

    @action
    private showReminders = (e: React.MouseEvent<HTMLButtonElement>) => {
        const toShowNext = !this.props.store.activities.showRemindersCenter;
        if (toShowNext) {
            this.props.store.activities.openActivitiesReminders();
        } else {
            this.props.store.activities.closeActivitiesReminders();
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/reminder/RemindersAlert.tsx